var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import * as searchFactory from '../../../classes/definitions/search/search';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import NotosService from '../../../classes/notos.service';
import AppRoutes from '../../../config/appRoutes';
import searchSchema from '../../../schemas/searchSchema';
import SearchService from '../../../services/search.service';
import Input from '../../UI/Input/Input';
var SearchForm = /** @class */ (function (_super) {
    __extends(SearchForm, _super);
    function SearchForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.bottomMessages = null;
        _this.SearchService = new SearchService(_this.api);
        _this.state = {
            formConfig: _.cloneDeep(searchSchema),
            formIsValid: false,
            brandsSuggestions: [],
            categoriesSuggestions: [],
        };
        _this.setupFieldsOptions = function (data) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            if (_this.editId !== '-1') {
                _this.props.isEdit(true);
                _this.setBarcodes(updatedFormConfig, _.get(data, 'products'));
                _this.setupOptionTypes(updatedFormConfig, _.get(data, 'status'));
                _this.setupSearchCombination(updatedFormConfig, _.get(data, 'value'));
            }
            _this.setState({ formConfig: updatedFormConfig }, function () {
                // After setting up the async options
                if (_this.editId !== '-1') {
                    _this.searchOneResult(_this.editId);
                }
            });
        };
        _this.searchOneResult = function (id) {
            _this.api
                .searchOneResult(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на продукта';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setBarcodes = function (updatedFormConfig, rawBarcodes) {
            for (var _i = 0, rawBarcodes_1 = rawBarcodes; _i < rawBarcodes_1.length; _i++) {
                var key = rawBarcodes_1[_i];
                updatedFormConfig.categories.value.push(key.id);
            }
        };
        _this.setupOptionTypes = function (updatedFormConfig, rawOptionTypes) {
            updatedFormConfig.option_type.value = rawOptionTypes;
        };
        _this.setupSearchCombination = function (updatedFormConfig, rawSearchCombination) {
            updatedFormConfig.search_value.value = rawSearchCombination;
        };
        _this.getSearch = function (id) {
            _this.api
                .searchOneResult(id)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на търсенето';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var search = searchFactory.createSearch(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _this.SearchService.setDataToSearchForm(updatedFormConfig, search);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = event.value;
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.deleteHandlers = function (event, id, eventType, elType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = '';
            if (elType === 'autocomplete') {
                if (event.value) {
                    updatedFormElement.value = '';
                }
            }
            else {
                updatedFormElement.value = event.target.value;
            }
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var categories = [];
            Object.keys(formData).forEach(function (key) {
                var value = _.get(formData, key + ".value", []);
                if (key.startsWith('autocompleteInput')) {
                    var index = key.replace('autocompleteInput', '');
                    var categoryValue = _.get(formData, "autocompleteInput" + index + ".value", []);
                    categories.push(categoryValue);
                }
            });
            formData.ivan = categories;
            var submittedSearch = searchFactory.createUpdateSearch({
                value: _.get(formData, 'search_value.value', ''),
                status: _.get(formData, 'option_type.value', null),
                categories: _.get(formData, 'ivan', []),
                autocompleteInput1: _.get(formData, 'autocompleteInput1.value', []),
                autocompleteInput2: _.get(formData, 'autocompleteInput2.value', []),
                autocompleteInput3: _.get(formData, 'autocompleteInput3.value', []),
                autocompleteInput4: _.get(formData, 'autocompleteInput4.value', []),
                autocompleteInput5: _.get(formData, 'autocompleteInput5.value', []),
            });
            var actionMethod = _this.editId === '-1' ? _this.api.createSearch : _this.api.updateSearch;
            actionMethod({ exact_search: submittedSearch }, _this.editId !== '-1' ? _this.editId : undefined)
                .then(function (response) {
                _this.bottomMessages.show({ severity: 'success', detail: 'Търсенето бе запазен успешно', life: 5000 });
                _this.toSearchesPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на търсене.';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.toSearchesPage = function () {
            _this.props.history.push(AppRoutes.searches.path);
        };
        _this.suggestOptions = function (event, type) {
            var searchString = event.query.toLowerCase();
            var searchMethod = _this.api.searchProducts;
            searchMethod(searchString)
                .then(function (response) {
                var data = _.get(response, 'data.data', []);
                var results = [];
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var item = data_1[_i];
                    results.push({
                        label: _.get(item, 'attributes.name', '') + " (" + _.get(item, 'attributes.price', '') + ")",
                        value: _.get(item, 'id'),
                        barcode: searchString,
                    });
                }
                var obj = {};
                obj['categoriesSuggestions'] = results;
                _this.setState(obj);
            })
                .catch(function (error) {
                var defaultMessage = 'Не можахме да намерим опции';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        return _this;
    }
    SearchForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getSearch(this.editId);
        }
    };
    SearchForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid, brandsSuggestions = _a.brandsSuggestions, categoriesSuggestions = _a.categoriesSuggestions;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onChange', formElement.config.elementType);
                    }, blur: function (event) {
                        return _this.eventHandlers(event, formElement.id, 'onBlur', formElement.config.elementType);
                    }, deleteButtonAction: function (event) {
                        return _this.deleteHandlers(event, formElement.id, 'onClick', formElement.config.elementType);
                    }, suggestions: formElement.config.elementType === 'autocomplete' ? categoriesSuggestions : [], deleteButton: formElement.config.elementType === 'autocomplete' ? true : false, completeMethod: function (event) { return _this.suggestOptions(event, formElement.id); } }),
                formElement.config.elementType === 'input' ? React.createElement("label", { className: "modalLabels " }, "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438") : ''));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toSearchesPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            React.createElement(Messages, { ref: function (el) {
                    _this.bottomMessages = el;
                } }),
            actionBtns));
    };
    return SearchForm;
}(React.Component));
// @ts-ignore
export default withRouter(SearchForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/Search/SearchForm/SearchForm.tsx
// module id = 454
// module chunks = 0